<template>
  <div class="auth-modal">
    <!-- Modal Starts Here -->
    <div
      class="modal fade"
      id="addEditPostToMapModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="addEditPostToMapModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header pb-0 border-0">
            <button id="dismissBtnAddEditPostToMap" type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                <ion-icon name="ios-close" size="large"></ion-icon>
              </span>
            </button>
          </div>
          <div class="modal-body pt-0">
            <div class="container">
              <div class="row justify-content-center">
                <div class="col-12 col-md-12 mb-3">
                  <h3 class="title mb-4">{{ mediaLocation ? 'Change Pin Location' : 'Pin To Map' }}</h3>
                    <div class="form-group">
                        <GmapMap :center="latLng" :options="mapOptions" style="height: 300px">
                            <GmapMarker ref="mapMarker" :position="latLng" :clickable="false" :draggable="true" @dragend="markerCallback($event)"/>
                        </GmapMap>
                        <small class="form-text text-muted mb-2">Use the marker to set the location on the map.</small>
                    </div>
                    
                    <div class="d-flex align-items-center justify-content-end">
                        <button v-if="mediaLocation" @click="removeLocation()" id="submitBtn" class="btn btn-danger text-white">Remove from map</button>
                        <button @click="done()" id="submitBtn" class="ml-3 btn btn-primary text-white">Done</button>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import swal from "sweetalert";

    export default {
        name: "AddEditPostToMap",
        props: ["post"],
        data() {
            return {
                latLng: null,
                mapOptions: {
                    zoom: 7,
                    scrollWheel: false,
                    zoomControl: true,
                    disableDefaultUI: true,
                    scaleControl: false,
                    rotateControl: false,
                    mapTypeControl: false,
                    streetViewControl: false,
                    fullscreenControl: false,
                    mapTypeId: this.$props.type || "terrain",
                },
            }
        },
        computed: {
            mediaLocation: function() {
                if (this.$props.post) {
                    return this.$props.post.media_flags.find(f => f.type === "location");
                }
                return null;
            }
        },
        watch: {
            "$props.post": {
                handler: function(val) {
                    if (val) {
                        const flag = val.media_flags.find(f => f.type === "location");
                        if (flag) {
                            this.latLng = JSON.parse(flag.value);
                        } else {
                            this.latLng = { lat: 9.0748812, lng: 7.465183 };
                        }
                    } else {
                        this.latLng = { lat: 9.0748812, lng: 7.465183 };
                    }
                },
                immediate: true,
                deep: true
            }
        },
        methods: {
            done() {
                const closeBtn = document.getElementById("dismissBtnAddEditPostToMap");
                swal({
                    text: this.mediaLocation ? `Change the location of this pin?` : `Pin this post to the map?`,
                    icon: "warning",
                    buttons: true,
                }).then((willAdd) => {
                    if (willAdd) {
                        const flag = this.$props.post.media_flags.find(f => f.type === "location");
                        let form;
                        if (flag) {
                            form = {
                                type: "location",
                                value: JSON.stringify(this.latLng),
                                media_id: flag.media_id,
                                _id: flag._id
                            }
                        } else {
                            form = {
                                type: "location",
                                value: JSON.stringify(this.latLng),
                                media_id: this.$props.post._id,
                            }
                        }
                        this.$emit("AddEditPostToMap", form);
                        closeBtn.click();
                        this.latLng = { lat: 9.0748812, lng: 7.465183 };
                    }
                })
            },
            removeLocation() {
                const closeBtn = document.getElementById("dismissBtnAddEditPostToMap");

                swal({
                    text: `Remove this post from map?`,
                    icon: "warning",
                    buttons: true,
                    dangerMode: true
                }).then((willDelete) => {
                    if (willDelete) {
                        this.$emit("RemovePostFromMap", this.mediaLocation);
                        closeBtn.click();
                        this.latLng = { lat: 9.0748812, lng: 7.465183 };
                    }
                })
            },
            markerCallback(e) {
                this.latLng = { lat: e.latLng.lat(), lng: e.latLng.lng() };
            }
        }
    }
</script>

<style scoped lang="scss" src="../../Auth/AuthModal/AuthModal.scss"></style>